import { mutatorAction } from 'satcheljs';
import type AugLoopViewState from '../store/schema/AugLoopViewState';
import type AnnotationHandler from '../store/schema/AnnotationHandler';
import type HandlerViewState from '../store/schema/HandlerViewState';
import { trace } from 'owa-trace';

export default mutatorAction(
    'setHandlerViewState',
    function setHandlerViewState(
        viewState: AugLoopViewState,
        handler: AnnotationHandler,
        handlerViewState: HandlerViewState
    ) {
        if (handlerViewState) {
            try {
                viewState?.handlerViewStates?.set(handler.name, handlerViewState);
            } catch (error) {
                trace.warn(
                    `[AugLoopPlugin] exception encountered when setting handler view states: ${error.message}`
                );
            }
        }
    }
);
